export default "__VITE_ASSET__evS$LuQN__"